import React from 'react';
import { s as styled } from './styled-112a8bd0.js';

const DefaultHtmlStyle = styled.div `
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 14px;
  }
  h5 {
    font-size: 12px;
  }
  h6 {
    font-size: 10px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
const HtmlRenderer = ({ content, className, }) => (React.createElement(DefaultHtmlStyle, { className: className, dangerouslySetInnerHTML: { __html: content } }));

export { HtmlRenderer as H };
